<template>
    <div>
        <div @click="postStudy()" class="item  p-p-2" :class="getItemClass"
             v-tooltip.top="showReport ? studyContent : ''">
            <!--            <select-teacher @onSelect="changeTeacher" :defaultValue="schedule && schedule.teacher"/>-->
            <div v-if=" user.role === 'ADMIN' && !showReport && !deleteMode" class=" p-grid p-col">
                <div v-if="loading " style="padding: 7px !important"
                     v-bind:class="`p-dropdown-item ${getSubjectClass}`">
                    -
                </div>
                <Inplace v-if="!loading " v-bind:class="getSubjectClass" @cancel="cancelSchedule('LESSON')"
                         @close="postSchedule('LESSON')"
                         cancelble closeIcon="pi-check"
                         :closable="true">
                    <template #display>
                        {{ getLessonName(subject, studyTeacher) }}
                    </template>
                    <template #content>
                        <select-lesson v-if="!showReport " v-on:onSelect="changeSubject" :defaultValue="subject"/>
                    </template>
                </Inplace>
            </div>
            <div v-else class=" p-grid p-col">
                <div v-if="loading" style="padding: 7px !important" v-bind:class="` ${getSubjectClass}`">
                    -
                </div>
                <div v-else style="padding: 7px !important" v-bind:class="` ${getSubjectClass}`">
                    {{ getLessonName(subject, studyTeacher) }}

                </div>

            </div>
            <div v-if="showGradeSelect()" class=" p-grid p-col">
                <div v-if="loading" style="padding: 7px !important" v-bind:class="`p-dropdown-item ${getGradeClass}`">
                    -
                </div>
                <Inplace v-if="!loading " v-bind:class="getGradeClass" @open="openGradeSelect"
                         @cancel="cancelSchedule('GRADE')" @close="postSchedule('GRADE')"
                         cancelble
                         closeIcon="pi-check" :closable="true">
                    <template #display>
                        <div>
                            {{ getGradeName() }}

                        </div>
                    </template>
                    <template #content>
                        <!--                    :replace-options="getDisabledGrades"-->

                        <select-grade :key="selectGradeKey" :defaultFirst="false" v-if="user.role === 'ADMIN'" v-on:onSelect="changeGrade"
                                      v-model="grade"/>
                    </template>
                </Inplace>
            </div>

            <div v-else class=" p-grid p-col  ">
                <div v-if="loading" style="padding: 7px !important" v-bind:class="`  ${getGradeClass}`">
                    -
                </div>
                <div v-else style="padding: 7px !important" v-bind:class="` ${getGradeClass}`">
                    {{ getGradeName() }}
                </div>

            </div>

        </div>
        <!--    :studObjSelected="studObjSelected"-->
        <!--    v-on:resetStudSelected="studObjSelected = null"-->
        <!--    v-on:postStudy="postStudy"-->
        <!--    v-on:deleteStudy="deleteStudy"-->
        <StudyShortDialog
                :subjectLessonSchedule="subject"
                :show="isDialogStudyAdd"
                :date="getCorrectDate()"
                :gradeId="this.schedule && this.schedule.grade"
                :lessonTime="lesson"
                v-on:postStudy="addStudy"
                v-on:deleteStudy="deleteStudy"
                :studObjSelected="getStudObjSelected()"
                v-on:closeDialog="
        () => {
          isDialogStudyAdd = false;
        }
      "

        >
        </StudyShortDialog>
    </div>
</template>

<script>
import {mapState} from "vuex";
import SelectLesson from "@/components/selects/SelectLesson";
import {getGrade, getGradeFullName, getGradeShortName, getLessonFullName, getTeacherFullName} from "@/utils/parseObj";

import Service from "@/service/Service";
import {deleteSchedule, getTeacherScheduleByDayAndLesson} from "@/views/Schedule/Schedule";
import SelectGrade from "@/components/selects/SelectGrade";
import StudyShortDialog from "@/dialogs/StudyShortDialog";


export default {
    service: null,
    name: "TeacherScheduleItem",
    components: {
        SelectGrade,
        SelectLesson,
        StudyShortDialog
    },
    props: {
        schedule: {
            type: Object,
            default: null
        },
        studyTeacher: {
            type: Object,
            default: null
        },
        day: {
            type: Object,
            default: null
        },
        lesson: {
            type: Object,
            default: null
        },
        teacher: {
            type: String,
            default: null
        },
        loading: {
            type: Boolean,
            default: false
        },
        isMultipleAllow: {
            type: Boolean,
            default: false
        },
        showReport: {
            type: Boolean,
            default: false
        },
        date: {
            type: Date,
            default: false
        },
        deleteMode: {
            type: Boolean,
            default: false
        },
    },
    watch: {
        loading(a, b) {
            this.subject = this.schedule?.subject ?? null
        },
        schedule(newValue, oldValue) {
            this.originalSubject = this.schedule?.subject ?? null
            this.originalTeacher = newValue?.teacher ?? null
            this.subject = newValue?.subject ?? null
            this.grade = newValue?.grade ?? null
            this.newSubject = null
            this.newTeacher = null
        }
    },
    computed: {
        getDisabledGrades(){
          //   console.log("((", this.isMultipleAllow ? [] : this.disabledGrades)
          //   this.selectGradeKey++
          // return this.isMultipleAllow ? [] : this.disabledGrades
            return []
        },
        studyContent() {
            if (this.studyTeacher && !this.loading) return this.studyTeacher.content
            return "לא דווח"
        },
        content() {
            if (this.studyTeacher && !this.loading) return this.studyTeacher.content
            return null
        },
        getSubjectClass() {
            let style = "lesson p-col-12 p-p-0"
            if (this.subject === null || this.loading) {
                style += " lesson-blank"
            }
            return style
        },
        getItemClass() {
            if (this.deleteMode) return "pointer "
            if (!this.showReport) return
            let style = ""
            if (this.studyTeacher !== null && this.subject !== null && !this.loading) {
                style += "study-exist"
            } else if (this.studyTeacher === null && this.subject !== null && !this.loading) {
                style += " study-miss"
            } else if (this.studyTeacher !== null && !this.loading) {
                style += " study-extra"
            }

            return style
        },
        getGradeClass() {
            let style = "grade p-col-12 p-p-0 "
            if (this.grade === null || this.loading) {
                style += " grade-blank"
            }
            return style
        },
        ...mapState(["subjectLesson", "user"]),
    },
    data() {
        return {
            isDialogStudyAdd: false,
            originalSubject: this.schedule?.subject ?? null,
            originalGrade: this.schedule?.grade ?? null,
            subject: this.schedule?.subject ?? null,
            grade: this.schedule?.grade ?? null,
            // originalSubject : JSON.parse(JSON.stringify(this.schedule.lesson)),
            newSubject: null,
            newGrade: null,
            disabledGrades: [],
            selectGradeKey: 0,
            // originalSchedule: JSON.parse(JSON.stringify(this.schedule)),
            // newSchedule: JSON.parse(JSON.stringify(this.schedule))
        }
    },
    methods: {
        showGradeSelect(){
            console.log("subject", this.subject)
            const canPostGrade = this.subject === null || this.grade !== null
            return  this.user.role === 'ADMIN' && !this.showReport && !this.deleteMode && canPostGrade
        },
        getStudObjSelected() {
            if (this.studyTeacher?.study) {
                return this.studyTeacher.study
            } else {
                return null
            }
        },
        getCorrectDate() {
            return this.date
            // return this.date.setHours( this.date.getHours() + 3)
        },
        addStudy(study) {
            // this.subject = study.subject.id
            if (this.studyTeacher === null) {
                this.studyTeacher = {content: study.content}

            } else {
                this.studyTeacher.content = study.content
            }
            this.studyTeacher.study = study

        },
        deleteStudy(study) {
            this.studyTeacher = null
        },
       async postStudy() {
            if (this.showReport && !this.deleteMode) {
                this.isDialogStudyAdd = true
            }

            if (this.deleteMode){
              await  deleteSchedule(this.schedule.schedule._id)
                this.$emit('deleteSchedule', this.schedule.schedule._id);

                console.log(this.schedule.schedule._id)
            }
        },
        async updateDisabledGrades() {
            //TODO
            this.disabledGrades = await getTeacherScheduleByDayAndLesson(this.day.id, this.lesson.id)
        },
        changeGrade(event) {
            this.newGrade = event.id
        },
        changeSubject(event) {
            this.newSubject = event
        },

        getLessonName(id, studyTeacher) {
            if (id && !this.loading) {
                return getLessonFullName(id)
            }
            if (studyTeacher && this.showReport && !this.loading) {
                if (studyTeacher.study.subject.id) {
                    return studyTeacher.study.subject.hebrewName
                } else {
                    return getLessonFullName(id || studyTeacher.study.subject)
                }
            }
            return '-'
        },
        getGradeName() {
            if (this.grade && !this.loading) {
                const name = getGradeShortName(this.grade)
                if (name === ' '){
                    return  'x'
                } else {
                   return name
                }
            }
            return "-"
        },
        // getGradeName(id ) {
        //     if (id && !this.loading) return getGradeShortName(id)
        //     return "-"
        // },
        getGrade(id) {
            if (id && !this.loading) return getGrade(id)
            return "-"
        },
        async postSchedule(eventType) {

            const _id = {
                lesson: this.lesson.id,
                day: this.day.id
            }

            if (eventType === "GRADE") {
                _id.grade = this.newGrade
            }
            const postObject = {_id, teacher: this.teacher}
            if (eventType === "GRADE") {
                postObject.subject = this.subject
            }
            if (eventType === "LESSON") {
                postObject.subject = this.newSubject.id

                _id.grade = this.grade || this.teacher

            }
            // if (eventType === "GRADE") {
            //     postObject.grade = this.newGrade || null
            //     postObject.subject = this.subject || null
            // }

            try {
                if (eventType === "LESSON") {
                    this.subject = this.newSubject.id
                }
                if (eventType === "GRADE") {
                    this.grade = this.newGrade
                }
                await this.service
                    .update(postObject, "schedule")
                this.$emit('deleteSchedule', null);

            } catch (e) {
                console.log(e)
                this.openNotification(
                    "danger",
                    `אופס`,
                    `העדכון לא נקלט במערכת`
                );
                this.cancelSchedule(eventType)
            }
        },
        openNotification(
            color,
            title,
            text,
            position = "right-left",
            duration = 3000
        ) {
            this.$vs.notification({color, position, title, text, duration, progress: 'auto'});
        },
        openGradeSelect() {
            this.updateDisabledGrades()

        },
        cancelSchedule(eventType) {
            if (eventType === "LESSON") {
                this.subject = this.originalSubject
            }
            if (eventType === "GRADE") {
                this.grade = this.originalGrade
            }
        }
    },
    created() {
        this.service = new Service();
    }

}
</script>

<style scoped>
.item {
    text-align: center;
    background: #f3feff;
    margin-right: 1px;
}

.lesson {
    background: #ffffe3;
    font-weight: bold;
}

.study {
    background: #c8f5c0;
    font-weight: bold;
}

.grade {
    background: #ebedfc;
    font-weight: bold;

}

.grade-blank {
    background: #e8e8e8;
}

.study-blank {
    background: #e8e8e8;
}

.study-miss {
    background: #f6c3c3
}

.study-exist {
    background: #d7f5c4;
}

.study-extra {
    background: #fcf0ad;
}

.lesson-blank {
    background: #e8e8e8;
}

.pointer{
    cursor: pointer;
}
.pointer:hover{
    scale: 1.08;
    filter: drop-shadow(0 0 0.5rem crimson);
    cursor: pointer;
}
</style>